import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_stipend_district",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "add_job",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_stipend_district_button",
  "data-kt-drawer-close": "#kt_drawer_stipend_district_close",
  "data-kt-drawer-width": "65.5vw"
}
const _hoisted_2 = {
  id: "kt_drawer_stipend_district",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = {
  class: "card-header bg-primary text-light",
  id: "kt_drawer_stipend_district_header"
}
const _hoisted_4 = { class: "fw-bolder text-light my-auto" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "icon-table" }, null, -1)
const _hoisted_6 = { class: "badge badge-info" }
const _hoisted_7 = { class: "badge badge-info" }
const _hoisted_8 = { class: "badge badge-info" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-sm btn-icon btn-active-primary-light me-n5",
    id: "kt_drawer_stipend_district_close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-light" })
  ])
], -1)
const _hoisted_10 = {
  class: "card-body p-2",
  id: "kt_drawer_stipend_district_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_drawer_stipend_district_body",
  "data-kt-scroll-dependencies": "#kt_drawer_stipend_district_header, #kt_drawer_stipend_district_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_11 = { class: "card mb-5 mb-xl-10" }
const _hoisted_12 = {
  class: "table mx-5 mt-5 w-auto",
  style: {"border":"1px solid #7da17d, width: 98% !important"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-left":"1px solid #a78951"} }, [
  /*#__PURE__*/_createElementVNode("th", {
    class: "text-center bg-success text-white",
    style: {"height":"4vh","font-size":"17px","font-weight":"bold"}
  }, " SL "),
  /*#__PURE__*/_createElementVNode("th", {
    class: "text-center text-white bg-success",
    style: {"height":"4vh","font-size":"17px","font-weight":"bold"}
  }, " District Name "),
  /*#__PURE__*/_createElementVNode("th", {
    class: "text-center text-white bg-success",
    style: {"height":"4vh","font-size":"17px","font-weight":"bold"}
  }, " District Name English "),
  /*#__PURE__*/_createElementVNode("th", {
    class: "text-center text-white bg-success",
    style: {"height":"4vh","font-size":"17px","font-weight":"bold"}
  }, " Is poor ")
], -1)
const _hoisted_14 = { style: {"border-bottom":"1px solid #9ee29e"} }
const _hoisted_15 = {
  class: "text-center",
  style: {"border-bottom":"1px solid #9ee29e"}
}
const _hoisted_16 = {
  class: "text-center",
  style: {"border-bottom":"1px solid #9ee29e"}
}
const _hoisted_17 = {
  class: "text-center",
  style: {"border-bottom":"1px solid #9ee29e"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h6", _hoisted_4, [
          _hoisted_5,
          _createTextVNode("Districts List [ Total: "),
          _createElementVNode("span", _hoisted_6, _toDisplayString(this.stipendDistricts.length), 1),
          _createTextVNode(" Below Poor Income Level: "),
          _createElementVNode("span", _hoisted_7, _toDisplayString(this.belowpoor), 1),
          _createTextVNode(" Upper Poor Income Level: "),
          _createElementVNode("span", _hoisted_8, _toDisplayString(this.upperpoor), 1),
          _createTextVNode(" ] ")
        ]),
        _hoisted_9
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("table", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stipendDistricts, (data, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  class: "bg-light",
                  style: {"border-left":"1px solid #a78951"}
                }, [
                  _createElementVNode("td", _hoisted_14, _toDisplayString(index + 1), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(data?.district_name_bng), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(data?.district_name_eng), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(data?.is_poor == 1 ? 'Yes' : 'No'), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}